import { PageHeader } from "../../../components/portfolio-risk-concentration/PageHeader";
import ScenarioReconciliationPanel from "./scenario/ScenarioReconciliationPanel";

/**
 * Reconciliation -- the wizard's 6th, always-enabled step (see ScenarioSimulatorPage.tsx's
 * SCENARIO_STEPS). Propose still keeps its own copy of this same panel as a tab too, for the
 * "check right after finalizing" case; this route is the persistent one, reachable straight
 * from the step trail no matter which step of the wizard you're currently on. Real gap this
 * closes: once a pledge proposal is approved, there was previously no path back to
 * reconciliation status for it except re-entering the wizard and clicking through to Propose
 * again -- reconciliation has nothing to do with actively building a NEW scenario, so it needs
 * to stay reachable independent of wizard progress.
 *
 * ScenarioReconciliationPanel is fully self-contained (its own useScenarioReconciliation()
 * fetch, no dependency on the wizard's in-memory ScenarioDraft), so mounting it here needed no
 * data plumbing. No own px-6 -- rendered inside ScenarioSimulatorPage's ManageLimitsShell,
 * which already supplies it, same as every other wizard step.
 */
export default function ScenarioReconciliationPage() {
  return (
    <div>
      <PageHeader
        title="Scenario Reconciliation"
        subtitle="Approved pledge proposals, matched against today's book -- which contracts have moved as proposed and which haven't yet."
      />
      <div className="mt-4">
        <ScenarioReconciliationPanel />
      </div>
    </div>
  );
}
